import configs from "../lib/configs";
import { Storage } from "@lightningjs/sdk";
import { STORAGE_KEYS } from "../lib/utils";
import { Metrics } from "@firebolt-js/sdk";

const baseApiUrl = process.env.APP_API_URL || `https://genapp-backend.alteox.app`;

export function api<T>(url: string, options?: any): Promise<T> {
    if (options?.params) {
        const searchParams = new URLSearchParams();
        Object.keys(options.params).forEach((key) => searchParams.append(key, options.params[key] as string));

        url += `?${searchParams.toString()}`;
    }
    // console.log(`api ${JSON.stringify(options)}`);

    let headers: any = {
        "Content-Type": "application/json",
        "x-api-key": "Hf2cIPMNHvH3lws8AMcuhwahP151wmqs",
        "x-app-id": configs.appId,
        "x-app-language": Storage.get(STORAGE_KEYS.selectedLanguage) || "en",
        "x-app-platform": Storage.get(STORAGE_KEYS.platform),
        "x-app-platform-os": Storage.get(STORAGE_KEYS.posttvOS),
        "x-app-device-id": Storage.get(STORAGE_KEYS.uid)
    };
    const token = Storage.get(STORAGE_KEYS.token);
    if (!!token) {
        headers.authorization = Storage.get(STORAGE_KEYS.token);
    }

    const externalToken = Storage.get(STORAGE_KEYS.externalToken);
    if (!!externalToken) {
        headers["authorization-external"] = Storage.get(STORAGE_KEYS.externalToken);
    }
    headers = {
        ...headers,
        ...(options?.headers || {})
    };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), (options?.timeout ?? 20000));

    return fetch(`${baseApiUrl}/${url}`, {
        method: options?.method || "POST",
        body: options?.body ? JSON.stringify(options.body) : undefined,
        headers: headers,
        signal: options?.signal ?? controller.signal
    })
        .finally(() => clearTimeout(timeoutId))
        .then(async (response) => {
            console.log(`FETCH RES: ${response.status}`);
            if (!response.ok) {
                const errorText = await response.text().catch(() => response.statusText);
                Metrics.error(
                    Metrics.ErrorType.NETWORK,
                    response.status.toString(),
                    "Fetch request could not be completed",
                    true
                );
                throw new Error(`HTTP ${response.status}: ${errorText}`);
            }

            return response.json();
        })
        .then((data) => {
            if (!data.data && data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                const error = data.errors[0];
                const errorMessage = error.message || "GraphQL error";
                const errorCode = error.extensions?.code;

                // Log the actual GraphQL error for debugging
                console.error("GraphQL error:", errorMessage, error);

                // If there's no error code, throw with the actual message (matching original behavior)
                if (!errorCode) {
                    throw new Error(`GraphQL Error: ${errorMessage}`);
                }

		// Even if there's an error code, we should still throw if data is null
                // This prevents "Cannot read property of null" errors downstream
                if (data.data === null || data.data === undefined) {
                    throw new Error(`GraphQL Error [${errorCode}]: ${errorMessage}`);
                }

            }

            return data;
        })
        .catch((error: Error) => {
            // Only log network errors, not GraphQL errors that we've already logged
            if (error.message.startsWith("HTTP") || error.message === "Failed to fetch" || error.name === "TypeError") {
                console.log("Fetch error ", `${baseApiUrl}/${url}`);
                console.log(error);
                Metrics.error(Metrics.ErrorType.NETWORK, "500", "Fetch request could not be completed", true);
            } else {
                // For GraphQL errors, we've already logged them above
                // Just re-throw without additional logging
            }
            throw error;
        });
}
